import React from "react";
import { useNavigate } from "react-router-dom";
import "antd/dist/antd.css";
import "./ShopButtons.scss";
import { Button } from "antd";

function ShopButtons({ backToRegister }) {
  let navigate = useNavigate();
  const backToRegisterFirst = () => {
    navigate("/registerFirst");
  };
  const backToRegisterss = () => {
    backToRegister();
  };
  return (
    <div className="shopButtons__container">
      <div className="shopButtons__body">
        <a onClick={backToRegisterFirst}>刪除選店</a>|
        <a onClick={backToRegisterss}>選擇此店</a>
      </div>
    </div>
  );
}

export default ShopButtons;
